!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (e = e || self).getXPath = n();
}(this, function () {
  function e() {
    return (e = Object.assign ? Object.assign.bind() : function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var o = arguments[n];
        for (var r in o) ({}).hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
      return e;
    }).apply(null, arguments);
  }
  var n = {
      ignoreId: !1
    },
    o = "undefined" != typeof Node,
    r = o ? Node.ELEMENT_NODE : 1,
    i = o ? Node.TEXT_NODE : 3,
    t = o ? Node.DOCUMENT_TYPE_NODE : 10;
  return function (o, d) {
    var f = e({}, n, d),
      a = o;
    if (a && a.id && !f.ignoreId) return '//*[@id="' + a.id + '"]';
    for (var p = []; a && (r === a.nodeType || i === a.nodeType);) {
      for (var u = 0, l = !1, N = a.previousSibling; N;) N.nodeType !== t && N.nodeName === a.nodeName && u++, N = N.previousSibling;
      for (N = a.nextSibling; N;) {
        if (N.nodeName === a.nodeName) {
          l = !0;
          break;
        }
        N = N.nextSibling;
      }
      var s = u || l ? "[" + (u + 1) + "]" : "";
      p.push(a.nodeType != i ? (a.prefix ? a.prefix + ":" : "") + a.localName + s : "text()" + (s || "[1]")), a = a.parentNode;
    }
    return p.length ? "/" + p.reverse().join("/") : "";
  };
});